import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import {
  CounterPattern,
  CouponClassification,
  CourseClassification,
  DisplayTiming,
  MenuBookProperty,
  SaleType,
} from './models';

const masterDataService = {
  getMenuBookProperty(): Promise<CommonResponse<{ menu_book_property: MenuBookProperty[] }>> {
    let url = '/master-data?types=menu_book_property';
    return axiosClient.get(url);
  },
  getCourseClassification(): Promise<CommonResponse<{ course_classification: CourseClassification[] }>> {
    let url = '/master-data?types=course_classification';
    return axiosClient.get(url);
  },
  getCouponClassification(): Promise<CommonResponse<{ coupon_classification: CouponClassification[] }>> {
    let url = '/master-data?types=coupon_classification';
    return axiosClient.get(url);
  },
  getDisplayTiming(): Promise<CommonResponse<{ display_timing: DisplayTiming[] }>> {
    let url = '/master-data?types=display_timing';
    return axiosClient.get(url);
  },
  getSaleType(): Promise<CommonResponse<{ sale_type: SaleType[] }>> {
    let url = '/master-data?types=sale_type';
    return axiosClient.get(url);
  },
  getCounterPattern(): Promise<CommonResponse<{ counter_pattern: CounterPattern[] }>> {
    let url = '/master-data?types=counter_pattern';
    return axiosClient.get(url);
  },
  getCourseOrderLimitType(): Promise<any> {
    let url = '/master-data?types=course_order_limit_type';
    return axiosClient.get(url);
  },
  getScreenBusinessType(department_id: number): Promise<any> {
    let url = `/master-data?types=screen_business_type&department_id=${department_id}`;
    return axiosClient.get(url);
  },
};

export default masterDataService;
